import {gql} from 'graphql-request';

export const getMxConfiguration = gql`
    query MyQuery($input: GetMxConfigurationInput!) {
        getMxConfiguration(input: $input) {
            accountNav {
                enabled
                links {
                    label
                    type
                    url
                }
            }
            footer {
                links {
                    type
                    label
                    url
                }
            }
            i18n {
                defaultLocale
                supportedLocales
            }
            leftNav {
                enabled
                displayPartnerLogo
                links {
                    label
                    type
                    url
                }
            }
            partnerDisplayName
            productDisplayName
            unverifiedPlansBanner {
                enabled
            }
        }
    }
`;
